import { useState } from "react";
import { Button } from "@/shared/components/ui/button";
import { BetterAddressPicker } from "@/shared/components/ui/better-address-picker";
import { Label } from "@radix-ui/react-label";

interface RealEstateEstimateFormProps {
  onEstimate: (address: string) => void;
  isLoading: boolean;
}

export function RealEstateEstimateForm({ onEstimate, isLoading }: RealEstateEstimateFormProps) {
  const [address, setAddress] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("📍 RealEstateEstimateForm - Submitting address:", address);
    if (address.trim()) {
      onEstimate(address.trim());
    } else {
      console.warn("⚠️ RealEstateEstimateForm - Address is empty or whitespace only");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="mb-4 mt-2">
        <Label htmlFor="address" className="text-sm font-light text-stone-800 block mb-2">
          Property Address
        </Label>
        <BetterAddressPicker
          value={address}
          onChange={(value) => setAddress(value)}
          placeholder="Search for an address..."
          disabled={isLoading}
        />
      </div>

      <Button type="submit" disabled={!address.trim() || isLoading} className="w-full">
        Get Estimate
      </Button>
      <div className="h-5"></div>
    </form>
  );
}
